module.exports = __webpack_public_path__ + "static/media/signup.bc44ba99.svg";